import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import { propsToDom } from 'core/helpers';
import { Container } from 'components/Container';
import { Panel } from 'components/Panel';
import media from 'styles/media';
import { rem } from 'styles/utils';
import { fontNarrow, Small } from 'styles/typography';

const CreditsComponent = ({ primary, items, slice_type, next_slice_type, ...others }) => {
  const { background } = primary;
  // const gallery = useMemo(() => items.filter(({ image }) => !!image?.url), [items]);

  return (
    <Panel {...propsToDom(others)} id={slice_type} nextId={next_slice_type} background={background}>
      <Container>
        <Grid style={{ '--length': Math.min(items.length, 4) }}>
          {items.map(({ label, value }, index) => {
            return (
              <Item key={index}>
                <strong>{label}</strong>
                <Small as="span">{value}</Small>
              </Item>
            );
          })}
        </Grid>
      </Container>
    </Panel>
  );
};

const Item = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: ${rem(20)} var(--margin);
  display: flex;
  align-items: baseline;
  box-shadow: inset 1px 0 0 0 ${({ theme }) => theme.colors.border};

  &:nth-child(4n + 1) {
    padding-left: 0;
    box-shadow: none;
  }

  &:nth-child(4n + 4) {
    padding-right: 0;
  }

  strong {
    ${fontNarrow};
    font-weight: 600;
    font-size: max(12px, ${rem(12)});
    line-height: ${16 / 12};
    letter-spacing: 0.2em;
    text-transform: uppercase;
    margin-right: ${rem(16)};
  }

  ${Small} {
    color: ${({ theme }) => theme.colors.black};
    opacity: 0.5;
  }

  [data-background='dark'] & {
    background: ${({ theme }) => theme.colors.black};
    box-shadow: inset 1px 0 0 0 ${({ theme }) => theme.colors.blackBorder};

    ${Small} {
      color: ${({ theme }) => theme.colors.white};
    }

    &:nth-child(4n + 1) {
      box-shadow: none;
    }
  }

  ${media.mobile`
    padding: ${rem(4)} 0 !important;

    strong {
      width: auto;
      margin-right: auto;
    }

    span {
      margin-left: ${rem(10)};
    }
  `}
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(var(--length, 4), minmax(10px, 1fr));
  border-bottom: 1px solid ${({ theme }) => theme.colors.black};

  [data-background='dark'] & {
    border-bottom-color: ${({ theme }) => theme.colors.blackBorder};
  }

  ${media.mobile`
    background: inherit !important;
    padding-top: ${rem(32 - 4)};
    padding-bottom: ${rem(16 - 4)};
    grid-template-columns: 1fr;
  `}
`;

export const Credits = styled(CreditsComponent)``;

export const query = graphql`
  fragment SliceCreditsHome on PrismicHomeDataBodyCredits {
    id
    slice_type
    primary {
      background
    }
    items {
      label
      value
    }
  }

  fragment SliceCreditsPage on PrismicPageDataBodyCredits {
    id
    slice_type
    primary {
      background
    }
    items {
      label
      value
    }
  }
`;
